namespace Areas.ContractorPay.Edit {
    "use strict";

    var tabItems = Areas.createTabsWithSameAction("ContractorPay", "Edit",
        ["Profile", "Summary", "Transaction", "Detail", "Information", "Payment", "EnterPayment", "EnterChangeOrder"]);

    export function tabInitialized(params: any) {
        return Areas.tabWithIdInitialized(tabItems)(params);
    }

    export function updateContractorPayProfile() {
        const form = $("#ContractorPayProfileForm").dxForm("instance");
        const newData: any = form.option("formData");
        const result: any = form.validate();
        const keyId: any = form.option("KeyId");

        if (result.isValid && keyId != null) {
            sendRequest(`/ContractorPay/Profile/Put/${keyId}`, JSON.stringify(newData), "PUT",
                () => Areas.refreshGrid("ContractorPayProfilesGrid"));
        }
    }

    export function returnToListFromTab() {
        var linkInfo = "/ContractorPay/List/Active";
        location.href = linkInfo;

    }

    export function onNewTransactionDetailRow(e: any) {
        const id = e.component.option("ContractScheduleValueId");
        e.data.contractScheduleValueId = id;
    }

    export function onNewTransactionRow(e: any) {
        const id = e.component.option("ContractScheduleValueProfileId");
        e.data.contractScheduleValueProfileId = id;
    }
}